import Joi from 'joi';

export const userFormSchema = Joi.object({
  first_name: Joi.string().required().label('First name'),
  last_name: Joi.string().required().label('Last name'),
  phone_number: Joi.string().allow('').optional().label('Phone number'),
  email: Joi.string().label('Email'),
});
